import { makeStateKey } from "@angular/core";

export const TRANSLATIONS_CACHE_KEY =
    makeStateKey<Record<string, string>>("translations");
